import { connect } from 'react-redux';
import { getTotalSelectedTickets } from '../../../containers/ticketSelection/utils/ticketUtils';
import { getLocaleProps } from '../../../selectors/app';
import { getApplePay } from '../../../selectors/applePay';
import { getSelectedTickets } from '../../../selectors/tickets';
import { CheckoutState } from '../../../state';
import { ApplepayNativeButtonProps } from './ApplepayNativeButton';

const _mapStateToProps = (
    state: CheckoutState,
): Partial<ApplepayNativeButtonProps> => ({
    totalTicketQuantity: getTotalSelectedTickets(getSelectedTickets(state)),
    defaultLocale: getLocaleProps(state).defaultLocale,
    applePay: getApplePay(state),
});

export type ConnectedProps = ReturnType<typeof _mapStateToProps>;

export const connectApplepayNativeButton = connect(_mapStateToProps);
